const initialState ={
    isloading :false,
    error:"",
    senders:[],
    chatBox:[],
    send:[]
}

const chatReducers = (state = initialState, action) => {
    switch (action.type) {
      case "sender_List_req":
        return {
          ...state,
          isLoading: true,
        };
      case "sender_List_success":
        return {
          ...state,
          isLoading: false,
          senders: action.payload,
        };
      case "sender_List_failure":
        return {
          ...state,
          isLoading: false,
          errors: action.payload,
        };
        case "sender_Message_req":
        return {
          ...state,
          isLoading: true,
        };
      case "sender_Message_success":
        return {
          ...state,
          isLoading: false,
          chatBox: action.payload,
        };
      case "sender_Message_failure":
        return {
          ...state,
          isLoading: false,
          errors: action.payload,
        };
        case "send_Message":
            return {
              ...state,
              isLoading: false,
              send: action.payload,
            };
      default:
        return state;
    }
  };
  export {  chatReducers };